import React, { useState } from "react";
import { View, StyleSheet, SafeAreaView, ScrollView } from "react-native";
import { Spacer } from "../../components";
import { useNavigation } from "@react-navigation/native";
import { translate } from "../../i18n/translate";
import { HomeParamsList, HomeScreenProps } from "../../navigation/home-stack/home-stack";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import Big from "big.js";
import { Grid, Container, Row, Column } from "ui-grid";
import { theme, typography, Text, Button, ButtonType, Icon } from "ui-components";
import { Footer } from "../../components/new/footer/footer";
import { BottomNav } from "../../components/layout/bottom-nav";
import { domusoResponsiveStyleHelper } from "./utils/domuso-responsive";
import { spacing } from "../../theme/spacing";
import automationTestingLocators from "./utils/automation-testing-locators.json";

export const PaymentFlowPaymentMethodCertifiedACH = ({ route }: HomeScreenProps) => {
  const navigation = useNavigation();
  let { params = {} as HomeParamsList } = route;
  const propertyFees = useSelector((state: RootState) => state.reservation.propertyFees);
  const [isLoading, setIsLoading] = useState(false);
  const logger = useSelector((state: RootState) => state.logger);
  const feeBA = Big(propertyFees?.domusoACH?.fee ? propertyFees?.domusoACH?.fee : 0);

  const onPressCertifiedBA = async () => {
    return navigation.navigate("PaymentFlowPaymentMethodCertifiedACHYodleeWidget", {
      ...params,
      certifiedPaymentType: "DCASH_BA",
      amounts: {
        amount: params.amounts.amount,
        platformFee: feeBA,
        total: feeBA.plus(params.amounts.amount || 0),
      },
    });
  };

  return (
    <SafeAreaView style={styles.container}>
      <Spacer size="large" />
      <ScrollView style={styles.scrollView} contentContainerStyle={styles.scrollableArea}>
        <View>
          <Grid>
            <Container>
              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column
                  span={{ xs: 12, sm: 8, md: 8, lg: 8 }}
                  style={[styles.inputRow, styles.cardTopStyle]}>
                  <View>
                    <PaymentHeading
                      heading={`${translate(
                        "paymentFlow.paymentMethodCertifiedBank.chooseDomusoOnlineCertified"
                      )}`}
                    />
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>
              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <Spacer size="medium" />
                  <Text
                    text={
                      translate(
                        "paymentFlow.paymentMethodCertifiedBank.descriptionParagraphA"
                      ) as string
                    }
                    style={styles.content}
                    {...automationTestingLocators.paymentFlowPaymentMethodCertifiedAch
                      .paymentDescriptionParagraphAText}
                  />
                  <Spacer size="medium" />
                  <Text
                    text={
                      translate(
                        "paymentFlow.paymentMethodCertifiedBank.descriptionParagraphB"
                      ) as string
                    }
                    style={styles.content}
                    {...automationTestingLocators.paymentFlowPaymentMethodCertifiedAch
                      .paymentDescriptionParagraphBText}
                  />
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>
              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }}></Column>
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <Spacer size="larger" />
                  <View style={styles.columnIcon}>
                    <Icon
                      size={theme.iconSize.small}
                      name={"ios-tick"}
                      color={theme.colors.primary}
                    />
                    <Text
                      text={
                        translate(
                          "paymentFlow.paymentMethodCertifiedBank.fastAndEffortlessLabel"
                        ) as string
                      }
                      style={styles.sectionSubHeading}
                      {...automationTestingLocators.paymentFlowPaymentMethodCertifiedAch
                        .fastAndEffortlessTitle}
                    />
                  </View>
                  <Text
                    text={
                      translate(
                        "paymentFlow.paymentMethodCertifiedBank.fastAndEffortlessText"
                      ) as string
                    }
                    style={[styles.content, styles.contentSubHeading]}
                    {...automationTestingLocators.paymentFlowPaymentMethodCertifiedAch
                      .fastAndEffortlessText}
                  />
                </Column>
              </Row>
              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }}></Column>
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <Spacer size="medium" />
                  <View style={styles.columnIcon}>
                    <Icon
                      size={theme.iconSize.small}
                      name={"ios-tick"}
                      color={theme.colors.primary}
                    />
                    <Text
                      text={
                        translate("paymentFlow.paymentMethodCertifiedBank.secureLabel") as string
                      }
                      style={styles.sectionSubHeading}
                      {...automationTestingLocators.paymentFlowPaymentMethodCertifiedAch
                        .secureTitle}
                    />
                  </View>
                  <Text
                    text={translate("paymentFlow.paymentMethodCertifiedBank.secureText") as string}
                    style={[styles.content, styles.contentSubHeading]}
                    {...automationTestingLocators.paymentFlowPaymentMethodCertifiedAch.secureText}
                  />
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>
            </Container>
          </Grid>
        </View>
      </ScrollView>

      <BottomNav backgroundColor={theme.colors.white}>
        <View style={{ marginTop: 25 }}></View>
        <Row>
          <Column span={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Spacer size="massive" />
          </Column>
        </Row>
        <Row>
          <Column span={{ xs: false, sm: 3, md: 3, lg: 3 }} />
          <Column span={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Button
              text={translate("paymentFlow.paymentMethodCertifiedBank.continue") as string}
              onPress={() => {
                onPressCertifiedBA();
              }}
              type={ButtonType.primary}
              disabled={false}
              loading={isLoading}
              {...automationTestingLocators.paymentFlowPaymentMethodCertifiedAch.continueButton}
            />
          </Column>
          <Column span={{ xs: false, sm: 3, md: 3, lg: 3 }} />
        </Row>
      </BottomNav>
      <Footer />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...domusoResponsiveStyleHelper({
      webPhone: {
        backgroundColor: "#FFFFFF",
      },
      webTablet: {
        backgroundColor: "#FAFAFA",
      },
      webDesktop: {
        backgroundColor: "#FAFAFA",
      },
      iosPhone: {
        backgroundColor: "#FFFFFF",
      },
      iosTablet: {
        backgroundColor: "#FAFAFA",
      },
      androidPhone: {
        backgroundColor: "#FFFFFF",
      },
      androidTablet: {
        backgroundColor: "#FAFAFA",
      },
    }),
  },
  scrollableArea: {
    ...domusoResponsiveStyleHelper({
      webPhone: { backgroundColor: "#FFFFFF", paddingBottom: 10 },
      webTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
      webDesktop: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
      iosPhone: { backgroundColor: "#FFFFFF", paddingBottom: 200 },
      iosTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
      androidPhone: { backgroundColor: "#FFFFFF", paddingBottom: 200 },
      androidTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
    }),
  },
  scrollView: {
    flexGrow: 0,
  },
  inputRow: {
    ...domusoResponsiveStyleHelper({
      webPhone: {},
      webTablet: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "white",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      webDesktop: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "white",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      iosPhone: {},
      iosTablet: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "white",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      androidPhone: {},
      androidTablet: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "white",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
    }),
  },
  content: {
    ...typography.body,
    color: theme.colors.text3,
  },
  sectionSubHeading: {
    ...typography.title2,
    fontFamily: "Lato_700Bold",
    color: theme.colors.primary,
    marginLeft: spacing.small,
  },
  contentSubHeading: {
    marginLeft: spacing.larger,
  },
  columnIcon: {
    flexDirection: "row",
    flex: 1,
    alignContent: "center",
    alignItems: "center",
  },
  columnStyle: {
    alignItems: "center",
  },
  cardTopStyle: {
    ...domusoResponsiveStyleHelper({
      webPhone: {},
      webTablet: {
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderTopWidth: 1,
        borderTopColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",

        background: "#FFFFFF",
      },
      webDesktop: {
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,
        paddingTop: spacing.large,

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderTopWidth: 1,
        borderTopColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      iosPhone: {},
      iosTablet: {
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderTopWidth: 1,
        borderTopColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      androidPhone: {},
      androidTablet: {
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderTopWidth: 1,
        borderTopColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
    }),
  },
});

const PaymentHeading = ({ heading }: any) => {
  return (
    <Row>
      <Column>
        <View>
          <Text
            style={[
              typography.heading2,
              { fontFamily: "Lato_700Bold", color: theme.colors.secondary, textAlign: "center" },
            ]}
            {...automationTestingLocators.paymentFlowPaymentMethodCertifiedAch.headerTitle}>
            {heading}
          </Text>
        </View>
      </Column>
    </Row>
  );
};

export default PaymentFlowPaymentMethodCertifiedACH;
